import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

export const DatePickerFilter = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const startDate = useSelector((state) => state.laser.selectedFilters.startDate);
  const endDate = useSelector((state) => state.laser.selectedFilters.endDate);
  const calendarEndDate = useSelector((state) => state.laser.currentUser.calendarEndDate);
  const { first_data_date } = useSelector((state) => state.laser.funnelChartData);

  return (
    <ReactDatePicker
      isRangePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      firstDataDate={first_data_date}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
};
